(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antique-moodboard"] && !Shopify.designMode) return;
  try {
    
  class AntiqueMoodboard extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.moodboard__item'));
      this.filters = Array.from(this.querySelectorAll('.moodboard__filter'));
      this.dialog = this.querySelector('.moodboard__lightbox');
      this.lightboxImage = this.querySelector('.moodboard__lightbox-image');
      this.lightboxMeta = this.querySelector('.moodboard__lightbox-meta');
      this.current = 0;

      this.filters.forEach((button) => {
        button.addEventListener('click', () => this.applyFilter(button.dataset.filter));
      });

      this.items.forEach((item) => {
        const opener = item.querySelector('.moodboard__open');
        if (opener) opener.addEventListener('click', () => this.open(item));
      });

      if (!this.dialog) return;

      this.dialog.addEventListener('click', (event) => {
        const action = event.target.closest('[data-action]');
        if (action) {
          const name = action.dataset.action;
          if (name === 'close') this.dialog.close();
          if (name === 'prev') this.step(-1);
          if (name === 'next') this.step(1);
          return;
        }
        if (event.target === this.dialog) this.dialog.close();
      });

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });

      this.dialog.addEventListener('close', () => {
        document.documentElement.style.removeProperty('overflow');
        if (this.lastOpener) this.lastOpener.focus({ preventScroll: true });
      });

      let startX = null;
      this.dialog.addEventListener('pointerdown', (event) => {
        startX = event.clientX;
      });
      this.dialog.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const distance = event.clientX - startX;
        startX = null;
        if (Math.abs(distance) > 50) this.step(distance < 0 ? 1 : -1);
      });
    }

    visibleItems() {
      return this.items.filter((item) => !item.hidden && item.querySelector('.moodboard__open'));
    }

    applyFilter(category) {
      this.items.forEach((item) => {
        item.hidden = category !== 'all' && item.dataset.category !== category;
      });
      this.filters.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.filter === category));
      });
    }

    open(item) {
      const visible = this.visibleItems();
      this.current = Math.max(0, visible.indexOf(item));
      this.lastOpener = item.querySelector('.moodboard__open');
      this.render();
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }

    step(direction) {
      const visible = this.visibleItems();
      if (visible.length < 2) return;
      this.current = (this.current + direction + visible.length) % visible.length;
      this.render();
    }

    render() {
      const visible = this.visibleItems();
      const opener = visible[this.current] && visible[this.current].querySelector('.moodboard__open');
      if (!opener) return;
      this.lightboxImage.src = opener.dataset.full;
      this.lightboxImage.alt = opener.dataset.alt || '';
      const parts = [opener.dataset.label, opener.dataset.caption].filter(Boolean);
      this.lightboxMeta.textContent = parts.join(' — ');
      this.dialog.classList.toggle('moodboard__lightbox--single', visible.length < 2);
    }
  }

  if (!customElements.get('antique-moodboard')) {
    customElements.define('antique-moodboard', AntiqueMoodboard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["antique-withdrawal"] && !Shopify.designMode) return;
  try {
    
  class AntiqueWithdrawal extends HTMLElement {
    connectedCallback() {
      const key = 'antique-withdrawal-sent-at';
      const isEn = this.dataset.locale === 'en';
      const format = (date) => {
        const day = date.toLocaleDateString(isEn ? 'en-GB' : 'fr-FR', { timeZone: 'Europe/Paris' });
        const time = date.toLocaleTimeString(isEn ? 'en-GB' : 'fr-FR', {
          timeZone: 'Europe/Paris',
          hour: '2-digit',
          minute: '2-digit',
        });
        return `${day} ${isEn ? 'at' : 'à'} ${time}`;
      };

      const sentAt = this.querySelector('[data-antique-sent-at]');
      if (sentAt) {
        let stored = null;
        try {
          stored = sessionStorage.getItem(key);
          sessionStorage.removeItem(key);
        } catch (error) {
          stored = null;
        }
        const date = stored ? new Date(Number(stored)) : null;
        if (date && !Number.isNaN(date.getTime())) sentAt.textContent = format(date);
        return;
      }

      const form = this.querySelector('form');
      const field = this.querySelector('[data-antique-sent-field]');
      if (!form || !field) return;
      form.addEventListener('submit', () => {
        const now = new Date();
        field.value = `${format(now)} (${isEn ? 'Paris time' : 'heure de Paris'})`;
        try {
          sessionStorage.setItem(key, String(now.getTime()));
        } catch (error) {
          /* stockage indisponible : l'heure du serveur reste affichée */
        }
      });
    }
  }

  if (!customElements.get('antique-withdrawal')) {
    customElements.define('antique-withdrawal', AntiqueWithdrawal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
